const questions = [
  { q: 'Какую компетенцию развиваем?', d: 'Например, умение проводить переговоры или давать обратную связь.' },
  { q: 'Зачем она нужна?', d: 'Какую задачу сотрудника или подразделения решает эта компетенция.' },
  { q: 'Какой текущий уровень?', d: 'Что сотрудник уже умеет, по результатам диагностики.' },
  { q: 'Какой уровень необходимо получить?', d: 'Целевое состояние, которое можно описать и проверить.' },
  { q: 'Какие действия выполняет сотрудник?', d: 'Обучение, практика, развивающие задачи, участие в проектах.' },
  { q: 'Кто помогает?', d: 'Руководитель, наставник, коллеги, тренер.' },
  { q: 'Как измеряется прогресс?', d: 'Понятные признаки изменения поведения, а не только «стал лучше».' },
  { q: 'Когда проводится повторная оценка?', d: 'Конкретный срок, к которому мы проверяем результат.' },
];

export default function IndividualPlans() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Как превратить развитие в конкретный план
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Развитие «в общем» не работает. Индивидуальный план развития (ИПР) переводит намерение в конкретные действия и сроки.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
          {questions.map((item, i) => (
            <div key={i} className="bg-gray-50 rounded-xl border border-gray-100 p-5 md:p-6">
              <h3 className="text-base font-bold text-gray-900 mb-1.5">{item.q}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{item.d}</p>
            </div>
          ))}
        </div>

        <div className="bg-teal-50 rounded-2xl border border-teal-100 p-6 md:p-8">
          <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-3">
            Пример структуры ИПР
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
            <div className="bg-white rounded-xl border border-teal-100 p-4">
              <p className="text-xs text-teal-700 font-semibold uppercase tracking-wide mb-1.5">Компетенция</p>
              <p className="text-gray-800 font-medium">Проведение переговоров с клиентами</p>
            </div>
            <div className="bg-white rounded-xl border border-teal-100 p-4">
              <p className="text-xs text-teal-700 font-semibold uppercase tracking-wide mb-1.5">Текущий → целевой уровень</p>
              <p className="text-gray-800 font-medium">Ведёт простые переговоры → уверенно ведёт сложные переговоры</p>
            </div>
            <div className="bg-white rounded-xl border border-teal-100 p-4">
              <p className="text-xs text-teal-700 font-semibold uppercase tracking-wide mb-1.5">Срок повторной оценки</p>
              <p className="text-gray-800 font-medium">Через 2 месяца после обучения</p>
            </div>
          </div>
          <p className="text-xs text-gray-500 mt-4 leading-relaxed">
            Это пример логики плана. Реальная структура ИПР подстраивается под компетенцию, роль сотрудника и задачи компании — без выдуманных корпоративных показателей.
          </p>
        </div>
      </div>
    </section>
  );
}